
import cSection from "../assets/images/obs/c-section.jpg"
import Fibroid from "../assets/images/obs/Fibroid.jpg"
import Infections from "../assets/images/obs/Infections.jpg"
import Laparoscopic from "../assets/images/obs/Laparoscopic.jpg"
import Menstrual from "../assets/images/obs/Menstrual.jpg"
import noraml from "../assets/images/obs/noraml.jpg"
import painless from "../assets/images/obs/painless.jpg"
import PCOS from "../assets/images/obs/PCOS.jpg"
import Pelvic from "../assets/images/obs/Pelvic.jpg"
import postcare from "../assets/images/obs/postcare.jpg"
import Pregnancy from "../assets/images/obs/Pregnancy-care.jpg"
import Vaccination from "../assets/images/obs/Vaccination.jpg"
import Hysterectomy from "../assets/images/obs/hysterectomy.jpeg"
import Myomectomy from "../assets/images/obs/myomectomy.jpeg"
import Colposcopy from "../assets/images/obs/colposcopy.jpeg"
import CryoCautery from "../assets/images/obs/cryo-cautery.jpeg"

import {
  Baby,
  User,
  Heart,
  Activity,
  Stethoscope,
  Syringe,
  Ribbon,
  Bug,
  Scissors,
  Droplet,
  UserCircle,
  ClipboardPlus,
} from "lucide-react";

export const servicesData = [
  // 🔹 Pregnancy Care
  {
    id: 1,
    category: "pregnancy",
    parentSlug: "pregnancy-care",
    title: "C-Section Delivery",
    slug: "c-section-delivery",
    shortDescription:
      "Safe and advanced cesarean delivery with expert care for both mother and baby.",
    icon: Baby,
    image:cSection,
  },
  {
    id: 2,
    category: "pregnancy",
    parentSlug: "pregnancy-care",
    title: "Normal Delivery",
    slug: "normal-delivery",
    shortDescription:
      "Natural birthing experience supported by experienced gynecologists and modern facilities",
    icon: User,
    image:noraml,
  },
  {
    id: 3,
    category: "pregnancy",
    parentSlug: "pregnancy-care",
    title: "Painless Delivery",
    slug: "painless-delivery",
    shortDescription:
      "Advanced epidural and pain-free delivery methods for a smooth birthing experience.",
    icon: Heart,
    image:painless,
  },
  {
    id: 4,
    category: "pregnancy",
    parentSlug: "pregnancy-care",
    title: "Postpartum Care",
    slug: "postpartum-care",
    shortDescription:
      "Comprehensive post-birth recovery plans ensuring the well-being of mothers.",
    icon: Activity,
    image:postcare,
  },
  {
    id: 5,
    category: "pregnancy",
    parentSlug: "pregnancy-care",
    title: "Pregnancy Care",
    slug: "pregnancy-care",
    shortDescription:
      "Complete prenatal checkups, monitoring, and personalized pregnancy care guidance.",
    icon: Stethoscope,
    image:Pregnancy,
  },
  {
    id: 6,
    category: "pregnancy",
    parentSlug: "pregnancy-care",
    title: "Vaccination",
    slug: "vaccination",
    shortDescription:
      "Essential vaccinations to protect mother and child during and after pregnancy.",
    icon: Syringe,
    image:Vaccination,
  },

  // 🔹 Gynecology
  {
    id: 7,
    category: "gynecology",
    parentSlug: "gynecology",
    title: "Fibroid Treatment",
    slug: "fibroid-treatment",
    shortDescription:
      "Advanced treatments for uterine fibroids to improve reproductive and overall health.",
    icon: Ribbon,
    image:Fibroid,
  },
  {
    id: 8,
    category: "gynecology",
    parentSlug: "gynecology",
    title: "Infections & STIs",
    slug: "infections-stis",
    shortDescription:
      "Diagnosis and treatment for infections and sexually transmitted diseases.",
    icon: Bug,
    image:Infections,
  },
  {
    id: 9,
    category: "gynecology",
    parentSlug: "gynecology",
    title: "Laparoscopic Surgery",
    slug: "laparoscopic-surgery",
    shortDescription:
      "Minimally invasive procedures for faster recovery and minimal scarring.",
    icon: Scissors,
    image:Laparoscopic,
  },
  {
    id: 10,
    category: "gynecology",
    parentSlug: "gynecology",
    title: "Menstrual Health",
    slug: "menstrual-health",
    shortDescription:
      "Comprehensive care for menstrual irregularities, cramps, and overall cycle health.",
    icon: Droplet,
    image:Menstrual,
  },
  {
    id: 11,
    category: "gynecology",
    parentSlug: "gynecology",
    title: "PCOS Treatment",
    slug: "pcos-treatment",
    shortDescription:
      "Specialized treatment plans to manage PCOS symptoms and restore hormonal balance.",
    icon: UserCircle,
    image:PCOS,
  },
  {
    id: 12,
    category: "gynecology",
    parentSlug: "gynecology",
    title: "Pelvic Pain, Breast Examination, Pap Smears",
    slug: "pelvic-pain-pap-smear",
    shortDescription:
      "Comprehensive gynecological screenings and treatments for preventive care.",
    icon: ClipboardPlus,
    image:Pelvic,
  },

  {
  id: 13,
  category: "gynecology",
  parentSlug: "gynecology",
  title: "Hysterectomy Surgery",
  slug: "hysterectomy",
  shortDescription:
    "Advanced uterus removal surgery for fibroids, heavy bleeding, and other gynecological conditions.",
  icon: ClipboardPlus,
  image: Hysterectomy,
},

{
  id: 14,
  category: "gynecology",
  parentSlug: "gynecology",
  title: "Myomectomy Surgery",
  slug: "myomectomy",
  shortDescription:
    "Safe fibroid removal procedure that preserves the uterus and supports future fertility.",
  icon: ClipboardPlus,
  image: Myomectomy,
},

{
  id: 15,
  category: "gynecology",
  parentSlug: "gynecology",
  title: "Colposcopy Examination",
  slug: "colposcopy",
  shortDescription:
    "Detailed cervical examination for early detection of abnormalities and better reproductive health.",
  icon: ClipboardPlus,
  image: Colposcopy,
},

{
  id: 16,
  category: "gynecology",
  parentSlug: "gynecology",
  title: "Cryo Cautery Treatment",
  slug: "cryo-cautery",
  shortDescription:
    "Minimally invasive treatment to remove abnormal cervical cells using advanced freezing technique.",
  icon: ClipboardPlus,
  image: CryoCautery,
}
];
